import * as z from "zod/v4";

export const getSuggestedReturnAnalyticsQuestions = {
  name: "getSuggestedReturnAnalyticsQuestions" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ questions: z.array(z.string()), threadId: z.string() }),
};
